export const maxAmountOfGtins = 2000;
export const maxAmountOfArticleNumbers = 500;
